import React from 'react'
import {IconButton, SxProps, Theme, Tooltip} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined'
import {NEUTRAL_SCALE, SEMANTIC} from 'src/theme-new/tokens'

const ICON_DEFS = {
  delete:       {Icon: DeleteOutlineIcon,       color: SEMANTIC.error.main,   defaultLabel: 'Elimina'},
  info:         {Icon: InfoOutlinedIcon,         color: NEUTRAL_SCALE[500],    defaultLabel: 'Info'},
  download:     {Icon: FileDownloadOutlinedIcon, color: SEMANTIC.info.main,    defaultLabel: 'Scarica'},
  search:       {Icon: SearchIcon,               color: NEUTRAL_SCALE[500],    defaultLabel: 'Cerca'},
  close:        {Icon: CloseIcon,                color: NEUTRAL_SCALE[500],    defaultLabel: 'Chiudi'},
  edit:         {Icon: EditOutlinedIcon,         color: NEUTRAL_SCALE[500],    defaultLabel: 'Modifica'},
  videocam:     {Icon: VideocamOutlinedIcon,     color: SEMANTIC.info.main,    defaultLabel: 'Apri videoconsulto'},
  copy:         {Icon: ContentCopyOutlinedIcon,  color: NEUTRAL_SCALE[500],    defaultLabel: 'Copia'},
  view:         {Icon: VisibilityOutlinedIcon,   color: SEMANTIC.info.main,    defaultLabel: 'Visualizza'},
  openExternal: {Icon: OpenInNewIcon,            color: SEMANTIC.info.main,    defaultLabel: 'Apri in un\'altra app'},
  reschedule:   {Icon: UpdateOutlinedIcon,       color: NEUTRAL_SCALE[500],    defaultLabel: 'Sposta'},
} as const

export type ActionIconVariant = keyof typeof ICON_DEFS

interface ActionIconButtonProps {
  variant: ActionIconVariant
  onClick?: (e: React.MouseEvent) => void
  disabled?: boolean
  tooltip?: string
  'aria-label'?: string
  sx?: SxProps<Theme>
}

export default function ActionIconButton({
  variant,
  onClick,
  disabled,
  tooltip,
  'aria-label': ariaLabel,
  sx,
}: ActionIconButtonProps) {
  const {Icon, color, defaultLabel} = ICON_DEFS[variant]

  const button = (
    <IconButton
      size="small"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel ?? defaultLabel}
      sx={{color, ...sx}}
    >
      <Icon sx={{fontSize: 20}} />
    </IconButton>
  )

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        {/* span required when button may be disabled */}
        <span style={{display: 'inline-flex'}}>{button}</span>
      </Tooltip>
    )
  }
  return button
}
